import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { localizeDate as _localizeDate } from '../../../../utils/vuex';
import MapService from '../../../../services/mapService';
export default {
  name: 'IsFMBuildingMgmtTiles',
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    stateAggregationValue: function stateAggregationValue() {
      return this.isStateAggregation(this.state);
    },
    stateAggregationValidText: function stateAggregationValidText() {
      return "".concat(this.stateAggregationValue.value).concat(this.stateAggregationValue.unit);
    },
    stateAggregationValidTextFontSize: function stateAggregationValidTextFontSize() {
      if (this.stateAggregationValidText.length <= 3) {
        return 25;
      } else if (this.stateAggregationValidText.length <= 5) {
        return 22;
      } else if (this.stateAggregationValidText.length <= 7) {
        return 18;
      }

      return 16;
    },
    successColor: function successColor() {
      return MapService.markerColor('success');
    }
  }),
  methods: {
    localizeDate: function localizeDate(item) {
      return _localizeDate(item);
    },
    isBoolean: function isBoolean(item) {
      return item.properties.valueType && item.properties.valueType === 'boolean';
    },
    isPercentage: function isPercentage(item) {
      if (item.value && item.value.value !== null && item.properties.unit) {
        // TODO: cover other cases where the word is written out?
        // what about multi-language then
        if (item.properties.unit === '%') {
          return true;
        }
      }

      return false;
    },
    isTemperature: function isTemperature(item) {
      return item.properties.unit === '°C' || item.properties.unit === '°F';
    },
    isStateAggregation: function isStateAggregation(item) {
      if (item.properties.unit === 'State-Aggregation') {
        if ("".concat(item.value.value).trim() === '') {
          return true;
        }

        if (_typeof(item.value.value) !== 'object') {
          var jsonObj = JSON.parse(item.value.value);
          return jsonObj;
        }

        return item.value.value;
      }

      return false;
    }
  }
};